import { Link } from "react-router-dom";
import type { ContentItem } from "@/types/content";
import { formatViews, getCategoryById } from "@/utils/content";

interface Props {
  item: ContentItem;
  index?: number;
}

export default function ContentListItem({ item, index = 0 }: Props) {
  const category = getCategoryById(item.categoryId);
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 md:p-4 hover:border-primary-300 transition-colors cursor-pointer animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 50}ms` }}
    >
      <div className="w-24 sm:w-28 md:w-32 shrink-0 aspect-[2/3] rounded-md overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 国语对白影音资源封面`}
          title={`${item.title} 国语对白高清影音作品`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex-1 min-w-0 flex flex-col">
        <div className="flex items-start justify-between gap-2">
          <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
            {item.title}
          </h3>
          <span className="shrink-0 flex items-center gap-1 text-xs text-accent-600 font-medium">
            <i className="ri-star-fill" />
            {item.rating}
          </span>
        </div>
        <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-price-tag-3-line" />
            {category?.name}
          </span>
          <span>{item.year}</span>
          <span>{item.region}</span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" />
            {formatViews(item.views)}
          </span>
        </div>
        <p className="mt-2 text-xs md:text-[13px] text-foreground-600 leading-relaxed line-clamp-2">
          {item.summary}
        </p>
        <div className="mt-auto pt-2 hidden sm:flex flex-wrap gap-1.5">
          {item.genres.map((g) => (
            <span key={g} className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}